<div class="modal-header align-items-start">
  <div class="d-flex flex-column">
    <h4 class="modal-title mb-1">{{ isEdit ? ('manageEvent.addExpense.editTitle' | translate) : ('manageEvent.addExpense.title' | translate) }}</h4>
    <p class="text-muted small mb-0">{{ 'manageEvent.addExpense.requiredHint' | translate }}</p>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <div class="row g-5">
    <!-- Title -->
    <div class="col-12">
      <app-input-component
        [type]="'text'"
        [(value)]="title"
        [label]="('manageEvent.addExpense.expenseTitle' | translate) + ' *'"
        [placeholder]="'manageEvent.addExpense.titlePlaceholder' | translate"
        [floating]="true"
        [invalid]="isTitleInvalid"
      />
    </div>

    <!-- Description -->
    <div class="col-12">
      <div class="form-floating">
        <textarea
          class="form-control"
          [(ngModel)]="description"
          [placeholder]="'manageEvent.addExpense.descriptionPlaceholder' | translate"
          style="height: 100px;"
        ></textarea>
        <label>{{ 'manageEvent.addExpense.description' | translate }}</label>
      </div>
    </div>

    <!-- Amount and Currency -->
    <div class="col-md-8">
      <app-input-component
        [type]="'number'"
        [(value)]="amount"
        [label]="('manageEvent.addExpense.amount' | translate) + ' *'"
        [placeholder]="'0.00'"
        [floating]="true"
        [invalid]="isAmountInvalid"
      />
    </div>

    <div class="col-md-4">
      <app-selectorini
        [options]="currencies"
        [displayKey]="'label'"
        [valueKey]="'value'"
        [(value)]="currency"
        [label]="'manageEvent.addExpense.currency' | translate"
        [floating]="true"
        [searchable]="false"
        [disabled]="true"
      />
    </div>

    <!-- Receipt Images -->
    <div class="col-12">
      <label class="form-label fw-semibold">{{ 'manageEvent.addExpense.receiptImages' | translate }}</label>
      <div class="upload-area" (click)="fileInput.click()">
        <input
          #fileInput
          type="file"
          accept="image/*"
          multiple
          hidden
          (change)="onFilesSelected($event)"
        />
        <div class="text-center py-5">
          <i class="fa fa-cloud-upload-alt fs-2x text-muted mb-3"></i>
          <p class="text-muted mb-0">{{ 'manageEvent.addExpense.uploadHint' | translate }}</p>
          <p class="text-muted fs-7">{{ 'manageEvent.addExpense.uploadFormat' | translate }}</p>
        </div>
      </div>

      <!-- Selected Files Preview -->
      @if (selectedFiles.length > 0) {
        <div class="mt-4">
          <h6 class="fw-bold mb-3">{{ 'manageEvent.addExpense.selectedFiles' | translate }}</h6>
          <div class="d-flex flex-wrap gap-3">
            @for (file of selectedFiles; track $index) {
              <div class="file-preview">
                <img [src]="file | filePreview" class="preview-image" />
                <button
                  type="button"
                  class="btn btn-sm btn-danger remove-btn"
                  (click)="removeFile($index)"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            }
          </div>
        </div>
      }

      <!-- Existing Images (Edit mode) -->
      @if (isEdit && expense?.images && expense!.images!.length > 0) {
        <div class="mt-4">
          <h6 class="fw-bold mb-3">{{ 'manageEvent.addExpense.currentReceipts' | translate }}</h6>
          <div class="d-flex flex-wrap gap-3">
            @for (image of expense!.images!; track image.image_id) {
              @if (image.image_url) {
                <div class="file-preview clickable" (click)="openLightbox(image.image_url)">
                  <img [src]="image.image_url" class="preview-image" />
                  <div class="preview-overlay">
                    <i class="fa fa-search-plus"></i>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>

<!-- Lightbox -->
@if (lightboxImage) {
  <div class="lightbox-overlay" (click)="closeLightbox()">
    <button type="button" class="lightbox-close" (click)="closeLightbox()">
      <i class="fa fa-times"></i>
    </button>
    <img [src]="lightboxImage" class="lightbox-image" (click)="$event.stopPropagation()" />
  </div>
}

<div class="modal-footer">
  <app-button
    [variant]="'outline'"
    [label]="'common.cancel' | translate"
    (clicked)="activeModal.dismiss()"
  />
  <app-button
    [variant]="'primary'"
    [label]="saving ? ('common.saving' | translate) : (isEdit ? ('common.saveChanges' | translate) : ('manageEvent.addExpense.addExpenseBtn' | translate))"
    [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-save'"
    [disabled]="saving || uploading"
    (clicked)="save()"
  />
</div>
